// extracted by mini-css-extract-plugin
export default {"Form":"CreateUser_Form__uDyqT","Wrapper":"CreateUser_Wrapper__IsHXK"};